import React, { useState, useRef, useEffect } from "react";

export const Header = (props) => {
  const { data, lang } = props;
  const [showText, setShowText] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // 0. Garanti Oynatma
    if (videoRef.current) {
      videoRef.current.play().catch(err => console.log("Otomatik oynatma bekletildi:", err));
    }

    // 1. Yazıların 1.5 saniyede gelmesi (1500ms)
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 1500);

    // 2. Videonun tam 4.8 saniyede dondurulması (4800ms)
    const videoTimer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.pause(); 
      }
    }, 4800);

    // Bileşen kapandığında zamanlayıcıları temizle
    return () => {
      clearTimeout(textTimer);
      clearTimeout(videoTimer);
    };
  }, []);

  if (!data) return null;

  return (
    <header id="header" style={{ position: "relative", width: "100%", height: "100vh", overflow: "hidden", backgroundColor: "#0a192f" }}>
      
      {/* ARKA PLAN VİDEOSU - MOBİL İÇİN KESİN ÇÖZÜM */}
      <video
        ref={videoRef}
        autoPlay 
        muted
        playsInline // IOS için hayati önem taşır
        loop 
        style={{
          /* ESKİ TRANSFORM VE %50 KODLARI TAMAMEN SİLİNDİ, YERİNE BUNLAR GELDİ */
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0, 
          objectFit: "cover", // Ekranı tam ve orantılı kaplar
          objectPosition: "center", // Tam merkezdeki logoyu odakta tutar (sağa/sola kaymasını engeller)
        }}
      >
        <source src={process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/img/BG.mp4` : "/img/BG.mp4"} type="video/mp4" />
        Tarayıcınız video etiketini desteklemiyor.
      </video>

      {/* İÇERİK KATMANI */}
      <div 
        className="intro" 
        style={{ 
          position: "relative", 
          width: "100%", 
          height: "100%", 
          background: "transparent",
          zIndex: 1 
        }}
      >
        <div 
          className="overlay" 
          style={{ 
            position: "absolute", 
            top: 0, 
            left: 0, 
            width: "100%", 
            height: "100%", 
            backgroundColor: "rgba(10, 25, 47, 0.45)" // %45 Saydam lacivert filtre
          }}
        >
          <div className="container" style={{ height: "100%", display: "flex", alignItems: "center" }}>
            <div className="row" style={{ width: "100%" }}>
              
              <div 
                className={`col-xs-12 col-md-10 col-md-offset-1 intro-text ${showText ? 'text-fade-in' : 'text-hidden'}`}
                style={{
                  position: "relative",
                  zIndex: 2, 
                  opacity: 0, 
                  transform: "translateY(30px)", 
                  transition: "opacity 1.5s ease-out, transform 1.5s ease-out", 
                }}
              >
                <h1>
                  {data.title}
                  <span></span>
                </h1>
                
                <p>{data.paragraph}</p>
                
                <a
                  href="#about"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  {lang === "tr" ? "Daha Fazla Bilgi Edin" : lang === "ru" ? "Узнать больше" : "Learn More"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>
        {`
          .text-fade-in {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
          .text-hidden {
            opacity: 0 !important;
            transform: translateY(30px) !important;
          }
        `}
      </style>

    </header>
  );
};